import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BaseComponent } from '@ups/xplat/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-labeled-field',
  templateUrl: 'labeled-field.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  standalone: false,
})
export class LabeledFieldComponent extends BaseComponent {
  readonly label = input<string>('SampleLabel');
  readonly value = input<string>();
  readonly alignment = input<FieldAlignment>('justify');

  constructor() {
    super();
  }
}

export type FieldAlignment = 'left' | 'center' | 'justify' | 'right';
